import { render } from "./RakutenOrderApi.vue?vue&type=template&id=97d98df0"
import script from "./RakutenOrderApi.vue?vue&type=script&lang=js"
export * from "./RakutenOrderApi.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__